import { render, staticRenderFns } from "./prTable.vue?vue&type=template&id=0efdb139&scoped=true"
import script from "./prTable.vue?vue&type=script&lang=ts"
export * from "./prTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efdb139",
  null
  
)

export default component.exports